import { prefixObjectValues as pre } from '../utils';

const prefix = 'claims-table';

const table = pre(
  {
    grid: 'grid',
    row: 'row',
    sortOccurrenceDate: 'sort-occurrence-date-btn',
    sortClaimStatus: 'sort-claim-status-btn',
    sortSettlementAmt: 'sort-settlement-amt-btn',
    sortLiabilityCarrier: 'sort-liability-carrier-btn',
    occurrenceDate: 'occurrence-date',
    claimStatus: 'claim-status',
    settlementAmt: 'settlement-amt',
    liabilityCarrier: 'liability-carrier',
    editBtn: 'edit-btn',
    deleteBtn: 'delete-btn',
    addBtn: 'add-btn',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
};
